import { TooltipIconButton } from "@components/Atoms/TooltipIconButton";
import { cn } from "@core-ui/utils/cn";
import t from "@ext/localization/locale/translate";
import { FadeReveal } from "@ui-kit/Animate";

interface ClearPropertyValueButtonProps {
	className?: string;
	onClear: () => void;
}

export const ClearPropertyValueButton = ({ className, onClear }: ClearPropertyValueButtonProps) => {
	const onClick = (event: React.MouseEvent) => {
		event.preventDefault();
		event.stopPropagation();
		onClear();
	};

	return (
		<FadeReveal className={cn("shrink-0", className)} revealOnGroupInteraction>
			<TooltipIconButton
				aria-label={t("clear")}
				className="size-5 shrink-0"
				icon="circle-x"
				iconClassName="shrink-0"
				onClick={onClick}
				onPointerDown={(event) => event.stopPropagation()}
				size="sm"
				tooltip={t("clear")}
				variant="text"
			/>
		</FadeReveal>
	);
};
